import apiClient from "@/app/api/client";
import type { ListParams } from "@/shared/types/api";

export const cameraService = {
	list(params?: ListParams) {
		return apiClient.get("/cameras", { params }).then((r) => r.data);
	},
	get(id: number) {
		return apiClient.get(`/cameras/${id}`).then((r) => r.data);
	},
	create(data: Record<string, unknown>) {
		return apiClient.post("/cameras", data).then((r) => r.data);
	},
	update(id: number, data: Record<string, unknown>) {
		return apiClient.patch(`/cameras/${id}`, data).then((r) => r.data);
	},
	remove(id: number) {
		return apiClient.delete(`/cameras/${id}`).then((r) => r.data);
	},
	capture(id: number) {
		return apiClient.get(`/cameras/${id}/capture`).then((r) => r.data);
	},
};
